/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Err_Register_TitleInputs */

const es_cap_err_register_title = /** @type {(inputs: Cap_Err_Register_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al registrarse`)
};

const gl_cap_err_register_title = /** @type {(inputs: Cap_Err_Register_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao rexistrarse`)
};

const en_cap_err_register_title = /** @type {(inputs: Cap_Err_Register_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registration error`)
};

/**
* | output |
* | --- |
* | "Registration error" |
*
* @param {Cap_Err_Register_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_err_register_title = /** @type {((inputs?: Cap_Err_Register_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Err_Register_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_err_register_title(inputs)
	if (locale === "en") return en_cap_err_register_title(inputs)
	return es_cap_err_register_title(inputs)
});